// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1XwTo","requiredAsterisk":"Info_requiredAsterisk__iSYOX"};